/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LinkInfo } from '../models/LinkInfo';
import type { Pageable } from '../models/Pageable';
import type { PageLinkView } from '../models/PageLinkView';
import type { UpdatePromotionCostForm } from '../models/UpdatePromotionCostForm';
import type { UpdateVisibilityForm } from '../models/UpdateVisibilityForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LinkTrackingService {
    /**
     * Update visibility
     * Updates the visibility for a creator's link.
     * @returns any Visibility updated successfully
     * @throws ApiError
     */
    public static updateVisibility({
        creatorId,
        type,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The link type
         */
        type: string,
        requestBody: UpdateVisibilityForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/link-tracking/{creatorId}/{type}/update-visibility',
            path: {
                'creatorId': creatorId,
                'type': type,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized access`,
                403: `Access forbidden`,
                404: `Creator not found`,
            },
        });
    }
    /**
     * Update promotion cost
     * Updates the promotion cost for a creator's link.
     * @returns any Promotion cost updated successfully
     * @throws ApiError
     */
    public static updatePromotionCost({
        creatorId,
        type,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The link type
         */
        type: string,
        requestBody: UpdatePromotionCostForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/link-tracking/{creatorId}/{type}/update-promotion-cost',
            path: {
                'creatorId': creatorId,
                'type': type,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized access`,
                403: `Access forbidden`,
                404: `Creator not found`,
            },
        });
    }
    /**
     * Lists all tracking links by type
     * @returns string The links were successfully listed
     * @throws ApiError
     */
    public static links({
        creatorId,
        type,
        page,
        limit,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The link type
         */
        type: string,
        /**
         * The page number
         */
        page?: number,
        /**
         * The page size
         */
        limit?: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/link-tracking/{creatorId}/{type}',
            path: {
                'creatorId': creatorId,
                'type': type,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `The request was invalid`,
            },
        });
    }
    /**
     * Gets the link info
     * Gets the link info for a creator's link.
     * @returns LinkInfo The link info was successfully retrieved
     * @throws ApiError
     */
    public static linkInfo({
        creatorId,
        type,
        linkId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The link type
         */
        type: string,
        /**
         * The link id
         */
        linkId: number,
    }): CancelablePromise<LinkInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/link-tracking/{creatorId}/{type}/{linkId}',
            path: {
                'creatorId': creatorId,
                'type': type,
                'linkId': linkId,
            },
            errors: {
                400: `The request was invalid`,
            },
        });
    }
    /**
     * Lists all tracking links by type
     * @returns PageLinkView The links were successfully listed
     * @throws ApiError
     */
    public static paginatedLinks({
        creatorId,
        type,
        pagination,
        onlyVisible,
        page,
        limit,
        searchQuery,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The link type
         */
        type: string,
        pagination: Pageable,
        /**
         * Whether to only show visible links
         */
        onlyVisible?: boolean,
        /**
         * The page number
         */
        page?: number,
        /**
         * The page size
         */
        limit?: number,
        /**
         * query to search
         */
        searchQuery?: string,
    }): CancelablePromise<PageLinkView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/link-tracking/{creatorId}/{type}/paginated',
            path: {
                'creatorId': creatorId,
                'type': type,
            },
            query: {
                'onlyVisible': onlyVisible,
                'page': page,
                'limit': limit,
                'searchQuery': searchQuery,
                'pagination': pagination,
            },
            errors: {
                400: `The request was invalid`,
            },
        });
    }
}
